// extracted by mini-css-extract-plugin
module.exports = {"yourinfo_text_wrapper":"YourInfo_page_yourinfo_text_wrapper__3OXPE"};